module.exports = __webpack_public_path__ + "img/purple-pin.2b8dce12.png";